'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Eyebrow,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewGrid } from '@/app_lib/types/ArticlePreview';
import { getPrimarySection } from '@/app_lib/utils/utils';

export const ArticleCardGrid = ({
  article,
  className,
  priority,
  index = 1,
  source = 'section_grid',
}: {
  article: ArticlePreviewGrid;
  className?: string;
  priority?: boolean;
  index?: number;
  source?: 'section_grid' | 'carousel' | 'flood';
}) => {
  const primarySection = getPrimarySection(article.primarySectionId, article.sections);
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard
      className={className}
      variant='grid'
    >
      <Image
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'image',
          moduleType: source,
        })}
        image={article.image}
        imageAlt={article.imageAlt || article.title}
        priority={priority}
        url={article.url}
        variant='grid'
      />
      <div className='flex flex-col gap-sm'>
        {primarySection && (
          <Eyebrow
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'eyebrow',
              moduleType: source,
            })}
            sectionName={primarySection.name}
            sectionUrl={primarySection.url}
            variant='grid'
          />
        )}
        <Title
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'headline',
            moduleType: source,
          })}
          title={article.title}
          url={article.url}
          variant='grid'
        />
      </div>
      <div className='flex flex-col'>
        <AuthorByline
          authors={article.authors}
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'author',
            moduleType: source,
          })}
          variant='grid'
        />
        <CardDate
          dateGmt={article.dateGmt}
          variant='grid'
        />
      </div>
    </ArticleCard>
  );
};
